import { ValueOf } from '@/types/util';

export const EPaymentMethod = {
  DIRECT_BANK: '銀行口座ダイレクト',
  CREDIT_CARD: 'クレジットカード',
  PREPAID: 'プリペイド',
  HOUSE_PREPAID: 'ハウスプリペイド',
  MKP_BANK_PAY: 'MKP銀行支払',
  APPLE_PAY: 'Apple Pay',
  POINT: 'ポイント',
  WALLET: 'ウォレット',
  GIFT_CERTIFICATE: '商品券',
  SPLIT_PAYMENT: '分割決済',
} as const;

export type PaymentMethodKey = keyof typeof EPaymentMethod;
export type PaymentMethodValue = ValueOf<typeof EPaymentMethod>;

export const paymentMethodKeys = Object.keys(EPaymentMethod) as PaymentMethodKey[];

/** v-select用items */
export const paymentMethodItems = paymentMethodKeys
  .map((key) => ({
    title: EPaymentMethod[key],
    value: key,
  }));
